
import { guessCountColor } from '@/assets/colors'
import { defineComponent } from 'vue'

const __default__ = defineComponent({
    props: {
        count: {
            required: true,
            type: Number,
        },
    },
    computed: {
        color() {
            return guessCountColor;
        }
    }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b02bce72": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__